var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xEB\\xCE\\xD3\\xC8_1",
    "data-name": "\\xEB\\xCE\\xD3\\xC8 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 306.059,
    height: 306.7421,
    viewBox: "0 0 306.059 306.7421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.2;\n      }\n\n      .cls-2 {\n        fill: #fdcd02;\n      }\n\n      .cls-3 {\n        fill: #ebbf02;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.1535,80.227a8.1984,8.1984,0,0,0,8.1986-8.1987V19.13a8.1986,8.1986,0,1,0-16.3972,0V72.0283A8.1984,8.1984,0,0,0,158.1535,80.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.974,103.2512a8.1986,8.1986,0,0,0,11.5942-11.5949L65.1628,54.2512a8.1986,8.1986,0,1,0-11.5942,11.595Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5439,158.8365a8.1984,8.1984,0,0,0-8.1986-8.1985H18.4465a8.1986,8.1986,0,1,0,0,16.3972H71.3453A8.1984,8.1984,0,0,0,79.5439,158.8365Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.974,214.4219l-37.4054,37.405a8.1986,8.1986,0,1,0,11.5942,11.5949l37.4054-37.4049a8.1986,8.1986,0,0,0-11.5942-11.595Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1536,90.5642h0a68.2724,68.2724,0,0,0,0,136.5447h0a68.2724,68.2724,0,0,0,0-136.5447Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1535,237.4461a8.1985,8.1985,0,0,0-8.1986,8.1986v52.8988a8.1986,8.1986,0,0,0,16.3972,0V245.6447A8.1985,8.1985,0,0,0,158.1535,237.4461Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.3338,214.4219a8.1989,8.1989,0,0,0-11.5949,11.595l37.4049,37.4049a8.1989,8.1989,0,0,0,11.5951-11.5949Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.86,150.638H244.9616a8.1986,8.1986,0,0,0,0,16.3972H297.86a8.1986,8.1986,0,1,0,0-16.3972Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.5363,105.6524a8.1731,8.1731,0,0,0,5.7975-2.4012l37.4051-37.405a8.1989,8.1989,0,0,0-11.5951-11.595L213.7389,91.6563a8.1987,8.1987,0,0,0,5.7974,13.9961Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.6333,147.9056a68.2724,68.2724,0,0,0,68.2723,68.2724V79.6332A68.2724,68.2724,0,0,0,79.6333,147.9056Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.7071,8.1988V61.0974a8.1986,8.1986,0,0,0,8.1985,8.1988V0A8.1986,8.1986,0,0,0,139.7071,8.1988Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.7071,234.7139v52.8988a8.1984,8.1984,0,0,0,8.1985,8.1984V226.5153A8.1984,8.1984,0,0,0,139.7071,234.7139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.7262,92.32A8.1985,8.1985,0,1,0,92.32,80.7254L54.9149,43.32A8.1987,8.1987,0,0,0,43.3207,54.9154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.2962,147.9056a8.1985,8.1985,0,0,0-8.1988-8.1985H8.1988a8.1986,8.1986,0,1,0,0,16.3972H61.0974A8.1986,8.1986,0,0,0,69.2962,147.9056Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.7262,203.491,43.3207,240.8961A8.1986,8.1986,0,1,0,54.9149,252.491L92.32,215.0859A8.1985,8.1985,0,1,0,80.7262,203.491Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.1781,147.9056a68.2724,68.2724,0,0,0-68.2724-68.2724h0V216.178h0A68.2723,68.2723,0,0,0,216.1781,147.9056Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.1043,61.0974V8.1988A8.1986,8.1986,0,0,0,147.9056,0V69.2962A8.1986,8.1986,0,0,0,156.1043,61.0974Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.1043,287.6127V234.7139a8.1984,8.1984,0,0,0-8.1987-8.1986v69.2958A8.1984,8.1984,0,0,0,156.1043,287.6127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.086,203.491a8.1989,8.1989,0,1,0-11.595,11.5949l37.4051,37.4051a8.1988,8.1988,0,1,0,11.5949-11.5949Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.6127,139.7071H234.7139a8.1986,8.1986,0,1,0,0,16.3972h52.8988a8.1986,8.1986,0,1,0,0-16.3972Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.2885,94.7215A8.173,8.173,0,0,0,215.086,92.32l37.405-37.4049A8.1989,8.1989,0,1,0,240.8961,43.32L203.491,80.7254a8.1987,8.1987,0,0,0,5.7975,13.9961Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.8d06f92efd1dd3e0a5b656d3cc61bc37.svg";
export { ForwardRef as ReactComponent };